import type { IpAssets, SiteTheme } from "~/theme/types";

const IMG = "/images/ip/oneroomta";

export const oneroomtaTheme: SiteTheme = {
  slug: "oneroomta",
  tokens: {
    primary: "#f5a623",
    primarySoft: "rgba(245,166,35,0.15)",
    primaryHover: "#d98c10",
    primaryGlow: "245,166,35",
    bg: "#fffaf3",
    surface: "#fff3e0",
    text: "#3a2a1a",
    textBody: "#8a6a4a",
    textMuted: "#a08868",
  },
};

export const oneroomtaAssets: IpAssets = {
  imagesBase: IMG,
  logos: {
    ko: `${IMG}/logo_kr.webp`,
    en: `${IMG}/logo_en.webp`,
    ja: `${IMG}/logo_ja.webp`,
  },
  logoAlt: {
    ko: "원룸 조교님",
    en: "One-Room TA",
    ja: "원룸 조교님",
  },
  sectionTitles: {
    characters: `${IMG}/title_Characters.webp`,
    news: `${IMG}/title_news.webp`,
    goods: `${IMG}/title_goods.webp`,
  },
  heroVisuals: [
    // KV1 (메인) — C안: 가로 전체화면. 타이틀 없는 Clean 아트 + locale 로고 오버레이.
    {
      id: 1,
      bg: `${IMG}/hero_kv_c_bg.webp`,
      char: null,
      thumb: `${IMG}/kv_c_thumb.webp`,
      label: "KEY VISUAL 01",
    },
    // KV2 — A안: 가로 전체화면 (bg + 캐릭터 레이어 분리, 기존 자산 유지).
    {
      id: 2,
      bg: `${IMG}/hero_kv1_bg.webp`,
      char: `${IMG}/hero_character.webp`,
      thumb: `${IMG}/kv_a_thumb.webp`,
      label: "KEY VISUAL 02",
    },
    // KV3 — B안: 세로형(포스터). contain 으로 중앙 배치 + 블러 배경. 가로 전체화면 X.
    {
      id: 3,
      bg: `${IMG}/hero_kv_b_portrait.webp`,
      char: null,
      thumb: `${IMG}/kv_b_thumb.webp`,
      label: "KEY VISUAL 03",
      fit: "contain",
    },
  ],
  pvVideoIds: {
    ko: "MIGS_dy-teU",
    en: "MIGS_dy-teU",
    ja: "MIGS_dy-teU",
  },
  pvPreview: `${IMG}/pv_preview.mp4`,
  pvPreviewByLocale: {
    ko: `${IMG}/pv_preview.mp4`,
  },
  laftelOnly: `${IMG}/laftel_only.webp`,
  loading: {
    // 첫 화면 = KV1(C안). C 배경 + locale 로고를 우선 preload.
    assets: [`${IMG}/hero_kv_c_bg.webp`, `${IMG}/logo_kr.webp`],
    logoSrc: `${IMG}/logo_kr.webp`,
    logoAlt: "원룸 조교님",
  },
};
